















































































































/** @format */

import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import { queryMonthCardApplyDetail, queryMonthCardApplyReview } from '@/api/fixed-car-management';
import { carTypesMap } from '@/types/order-management/dictionaries';
import Utils from '@root/utils/common';
import { API_SERVER } from '@root/common/config';
export interface IForm {
  applyStatus: string;
  reviewResult: string;
}
@Component({
  components: {}
})
export default class signDetail extends Vue {
  @Prop({ type: String, default: '' })
  pkApplyId!: string;
  //是否审核页面
  @Prop({ type: Boolean, default: false })
  isReview?: boolean;

  @Prop({ type: String, default: '' })
  cardId?: string;

  reviewForm: IForm = {
    applyStatus: '',
    reviewResult: ''
  };
  carTypesList = Utils.toLabelVal(carTypesMap);
  dataForm: any = {
    // applyStatus: '无需审核',
    // applyTime: '2020-12-24 15:42:23',
    // category: '非固定车位',
    // contractEndDate: '2021-06-03 23:59:59',
    // contractStartDate: '2021-03-04 00:00:00',
    // packageName: '长租车-错时车-002',
    // packagePrice: '20.00',
    // parkName: '巧红测试标准停车场227',
    // period: '3',
    // phone: '18651676263',
    // pkApplyId: '20201224154223141010003000000304',
    // plateList: [],
    // price: '20.00',
    // spaceCode: 'V8880013',
    // useType: '出租',
    // userName: '陈俊迪'
  };
  // 详情列表
  changeParkingInfo = [
    {
      prop: 'parkName',
      label: '车场名称'
    },
    {
      prop: 'packageName',
      label: '收费套餐'
    },
    {
      prop: 'packageUseType',
      label: '车位用途'
    },
    {
      prop: 'packageArea',
      label: '授权区域'
    },
    {
      prop: 'packagefixed',
      label: '是否固定车位'
    },
    {
      prop: 'packagePeriod',
      label: '授权周期'
    },
    {
      prop: 'cardType',
      label: '卡类型'
    },
    {
      prop: 'packagePrice',
      label: '套餐单价'
    },
    {
      prop: 'spaceCode',
      label: '车位号'
    },
    {
      prop: 'category',
      label: '车位类别'
    },
    {
      prop: 'parkingNum',
      label: '泊车数量'
    }
  ];
  // 客户信息
  customerInfo = [
    {
      prop: 'userName',
      label: '姓名'
    },
    {
      prop: 'roomNumber',
      label: '房号'
    },
    {
      prop: 'phone',
      label: '联系电话'
    },
    {
      prop: 'cardNum',
      label: '身份证号'
    }
  ];
  // 购买信息
  buyInfo = [
    {
      prop: 'spaceNum',
      label: '车位个数'
    },
    {
      prop: 'parkingNum',
      label: '可泊车数量'
    },
    {
      prop: 'applyTime',
      label: '授权期限'
    },
    {
      prop: 'price',
      label: '订单金额'
    },
    {
      prop: 'desc',
      label: '备注'
    }
  ];
  //审核信息
  reviewInfo = [
    {
      prop: 'applyStatus',
      label: '申请状态'
    },
    {
      prop: 'reviewTime',
      label: '审核时间'
    },
    {
      prop: 'reviewer',
      label: '审核人'
    },
    {
      prop: 'reviewResult',
      label: '审核意见'
    }
  ];
  //付款信息
  payInfo = [
    {
      prop: 'payChannel',
      label: '付款渠道'
    },
    {
      prop: 'payTime',
      label: '付款时间'
    }
  ];
  //获取名称
  getCarType(value) {
    console.log(this.carTypesList);
    let a = [];
    if (value) {
      a = _.filter(this.carTypesList, function(o) {
        return o.value == value;
      });
      return a.length > 0 ? a[0].label : '--' || '--';
    }
    return '--';
  }

  //订单状态
  applyStatusList = Utils.toLabelVal(this.$store.state.dictionaries.allDictionaries.apply_status);
  get isApplyStatus() {
    return [{ label: '通过', value: '03' }, { label: '不通过', value: '02' }];
  }
  //获取审核状态
  getApplyStatusName(value) {
    let a = [];
    if (value) {
      a = _.filter(this.applyStatusList, function(o) {
        return o.value == value;
      });
      return a.length > 0 ? a[0].label : '--' || '--';
    }
    return '--';
  }

  spining: boolean = false;
  // 获取数据赋值
  async queryEditPark(pkApplyId) {
    this.spining = false;
    try {
      const { status, data, msg } = await queryMonthCardApplyDetail({ pkApplyId });
      this.dataForm = { ...data };
      const { spacePackage } = data;
      this.dataForm.packagefixed = spacePackage.fixed;
      this.dataForm.packageName = spacePackage.name;
      this.dataForm.packageArea = spacePackage.packageArea;
      this.dataForm.packageId = spacePackage.packageId;
      this.dataForm.packagePeriod = spacePackage.period;
      this.dataForm.packagePeriodNum = spacePackage.periodNum;
      this.dataForm.packagePrice = spacePackage.price;
      this.dataForm.packageType = spacePackage.type;
      this.dataForm.packageUseType = spacePackage.useType;
      this.dataForm.applyTime = data.contractStartDate + '至' + data.contractEndDate;
      console.log('dataForm', this.dataForm);
    } catch (error) {
      this.$message.error((error && error.msg) || '系统繁忙，请稍后再试');
    } finally {
      this.spining = true;
    }
  }
  created() {
    this.queryEditPark(this.pkApplyId);
  }
  reviewFlag: boolean = false;
  //审核
  private async changeCarOK() {
    console.log(this.applyStatusList);
    if (!this.reviewForm.applyStatus) return this.$message.error('请选择审核结果');
    if (this.reviewForm.applyStatus == '02' && !this.reviewForm.reviewResult)
      return this.$message.error('审核不通过时，审核意见必填');
    if (this.reviewFlag) return;
    this.reviewFlag = true;
    try {
      let { applyStatus, reviewResult } = this.reviewForm;
      const pkApplyId = this.pkApplyId;
      const cardId = this.cardId;
      const { status, data, msg } = await queryMonthCardApplyReview({
        pkApplyId,
        applyStatus,
        cardId,
        reviewResult
      });
      this.reviewFlag = false;
      if (status !== '9999') {
        this.$message.error(msg);
      } else {
        this.$message.success('审核成功');
        this.goBack();
      }
    } catch (e) {
      this.$message.error('接口调用失败');
      this.reviewFlag = false;
    }
  }
  previewVisible: boolean = false;
  previewImage: string = '';
  API_SERVER = API_SERVER;
  handlePreviewCancel() {
    this.previewVisible = false;
  }
  async handlePreview(url: string) {
    this.previewImage = url;
    this.previewVisible = true;
  }
  goBack() {
    this.$emit('goBack');
  }
}
